import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Router} from '@angular/router';


@Injectable({
  providedIn: 'root'
})

export class PlatformToolGmtChaptersContentHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  commandEmitter: EventEmitter<any>;

  constructor(private router: Router) {
    this.commandEmitter = new EventEmitter<any>();
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      switch (command.name) {
        default:
          this.commandEmitter.emit(command);
          break;
      }
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }
}
